import { useParams } from 'react-router-dom';

import { AppCreateLiveStreamPage } from '~/components/pages/AppCreateLiveStreamPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { useNavigate } from '~/components/utils/Navigation';

export const AppCreateLiveStreamRoute: React.FC = () => {
  const { appId } = useParams();
  const navigate = useNavigate();

  if (!appId) {
    navigate('/');

    return null;
  }

  return (
    <DashboardTemplate appId={appId} noAppPreviewOverlap>
      <AppCreateLiveStreamPage appId={appId} />
    </DashboardTemplate>
  );
};
